export function validateImageFile(file, { maxBytes = 2 * 1024 * 1024 } = {}) {
  if (!file || !/^image\//.test(file.type)) return { ok: false, reason: 'not-image' };
  if (file.size > maxBytes) return { ok: false, reason: 'too-large' };
  return { ok: true };
}

// Field name ('file') and response path (response.data.url) copied verbatim
// from the existing Quill imageUploader.upload handler in
// app/groovesell-ui/src/pages/resources/assets.vue (around lines 318-345).
export async function uploadImage(file, { uploadUrl, axios }) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post(uploadUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.url;
}
